import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Marker } from 'react-map-gl';

import palette from '../styles/palette';
import { Text, View } from '../Base';

import { setStopMarkerPopup } from '../../store/reducers/map';
import { MAP_POPUP_TYPES } from '../../constants/map';

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    marker: {
      '& *': {
        // Markers not selectable
        'user-select': 'none' /* supported by Chrome and Opera */,
        '-webkit-user-select': 'none' /* Safari */,
        '-khtml-user-select': 'none' /* Konqueror HTML */,
        '-moz-user-select': 'none' /* Firefox */,
        '-ms-user-select': 'none' /* Internet Explorer/Edge */,
      },
    },
    container: {
      width: pxToRem(38),
      height: pxToRem(38),
      flexShrink: 0,
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '50%',
      border: '1px solid #E8EDEB',
      boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.25)',
      backgroundColor: palette.typography.white.solid,
      cursor: 'pointer',
      '&:hover': {
        border: `1px solid ${palette.brandRedInfo}`,
      },
    },
    activeContainer: {
      border: `1px solid ${palette.brandRedInfo}`,
    },
    count: {
      color: palette.dpdBlack,
      textAlign: 'center',
      fontSize: pxToRem(14),
      fontWeight: 500,
      lineHeight: '16px',
      letterSpacing: '-0.28px',
    },
  };
});

const ClusterMarker = ({ feature, isActive }) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const onClusterClick = useCallback(() => {
    const coordinates = feature.geometry.coordinates;
    dispatch(
      setStopMarkerPopup({
        coordinates,
        stop: feature,
        type: MAP_POPUP_TYPES.CLUSTER,
      })
    );
  }, [dispatch, feature]);

  return (
    <Marker
      longitude={feature.geometry.coordinates[0]}
      latitude={feature.geometry.coordinates[1]}
      anchor={'bottom'}
      className={styles.marker}
      onClick={onClusterClick}
      key={feature.properties.cluster_id}
    >
      <View
        data-testid={`cluster-${feature.properties.cluster_id}`}
        className={clsx(styles.container, isActive && styles.activeContainer)}
      >
        <Text className={styles.count}>{feature.properties.point_count}</Text>
      </View>
    </Marker>
  );
};

export default memo(ClusterMarker);
